import { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useLoginMutation } from "./authApiSlice";
import { setUser } from "./authSlice";
import { Stack, TextField } from "@mui/material";
import { useRequestPasswordResetMutation } from "./passwordReset";


const Login = () => {
    const errorRef = useRef()
    const usernameRef = useRef()
    const passwordRef = useRef()
    const [errorMessage, setErrorMessage] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [login, {isLoading}] = useLoginMutation()
    const [requestPasswordReset] = useRequestPasswordResetMutation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleUserChange = (e) => setUsername(e.target.value)
    const handlePasswordChange = (e) => setPassword(e.target.value)

    useEffect(() => {setErrorMessage('')}, [username, password])
    useEffect(() => {usernameRef.current.focus()}, [])
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const userData = await login({username, password}).unwrap()
            if (userData.error){
                setErrorMessage(userData.error)
            } else {
                dispatch(setUser(userData))
                setUsername('')
                setPassword('')
                setErrorMessage('')
                navigate("/")
            }

        } catch (error) {
            setErrorMessage("Login failed")
            console.log(error)
        }
    }

    const handlePasswordResetRequest = (e) => {
        e.preventDefault()
        if(username === "") {
            setErrorMessage("Enter the username before requesting a password reset.")
            return
        }
        requestPasswordReset({
            username: username
        })
        setErrorMessage("Password reset request sent! Check your email.")
    }

    const content = isLoading ? <h1>Loading...</h1> : (
        <section className="login">
            <center>
            <Box sx={{margin: 2}}>
                <Paper sx={{padding: 2}}>
                    <Stack spacing={1}>
                    <Typography variant="h2" gutterBottom>Log in</Typography>
                    {errorMessage ? <Alert severity="error" ref={errorRef} className={errorMessage ? "errmsg" : "offscreen"} aria-live="assertive">{errorMessage}</Alert> : ""}
                    <form onSubmit={handleSubmit}>
                        <TextField type="text" id="username" ref={usernameRef} value={username} onChange={handleUserChange} label="Username" required /><br /><br />
                        <TextField type="password" id="password" ref={passwordRef} value={password} onChange={handlePasswordChange} label="Password" required /><br /><br />
                        <Button type="submit" variant="contained">Sign In</Button>
                    </form>
                    <Button variant='text' onClick={handlePasswordResetRequest}>Reset password</Button>
                    </Stack>
                </Paper>
            </Box>
            </center>
        </section>
    )
    return content
}

export default Login